module.exports = __webpack_public_path__ + "img/whatsapp.29d69561.svg";